import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import Video from "@/components/common/Video";
import React from "react";
import GridContainer from "@/components/common/GridContainer";
import BannerCard from "@/components/Banners/SubPage/Components/BannerCard";
import AssetWrapper from "@/components/Banners/SubPage/Components/AssetWrapper";

const Wrapper = styled.section`
    overflow: hidden;
    position: relative;
    height: 100svh;
	width: 100%;
    display: flex;
    align-items: flex-end;
    padding-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
    	padding-bottom: ${getCssSizeValue(48)};
    }
`;

const CommonVideo = styled(Video)`
	overflow: hidden;
	position: relative;
	width: 100%;
	height: 100%;
`

const StyledGridContainer = styled(GridContainer)`
	position: relative;
	z-index: 1;
	align-items: end;
`

export default function CardAndImageVariant({ data }) {
	const assetVideoUrl = data?.video?.url || ''
	const externalVideoUrl = data?.externalVideo?.url || ''
	const videoSrc = assetVideoUrl !== '' ? assetVideoUrl : externalVideoUrl

	return (
		<Wrapper>
			<AssetWrapper>
				<CommonVideo
					src={videoSrc}
					playing
					autoplay
				/>
			</AssetWrapper>

			<StyledGridContainer>
				<BannerCard data={data} />
			</StyledGridContainer>
		</Wrapper>
	)
}
